import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Actions, Categories, Labels } from '../../types/gtm';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { useAuth } from '../../hooks/useAuth';
import Checkmark from '../../static/img/feedback-success.svg';
import Icon from '../../components/Section/Icon';
import { Content } from './styles';
import { TitleModal } from '../AssociateAccounts/styles';

type LocationState = {
  nameAccount: string;
  activeAccount: boolean;
};

const ManagerAccounts = () => {
  const { user, logout } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const state = location.state as LocationState;
  const nameAccount = state?.nameAccount;
  const activeAccount = state?.activeAccount;

  const label = activeAccount
    ? Labels.ConnectedPartnerScreen
    : Labels.DisconnectedPartnerScreen;

  const labelInverted = !activeAccount
    ? Labels.ConnectedPartnerScreen
    : Labels.DisconnectedPartnerScreen;

  return (
    <>
      <>
        <Header
          user={user}
          onLogout={logout}
          showReturn
          screenMenu={Categories.AssociateAccounts}
          labelMenu={label + nameAccount}
          onReturn={({ handleInternalReturn }) => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.AssociateAccounts,
              event_action: Actions.ClickBack,
              event_label: label + nameAccount,
              bd_suser_code: user?.globoId,
            });

            handleInternalReturn();
          }}
        />
        <Container>
          <Content>
            <TitleModal>
              <Icon svg={Checkmark} />
              {activeAccount ? (
                <p>Conexão removida</p>
              ) : (
                <p>Conexão adicionada</p>
              )}
            </TitleModal>
            {activeAccount ? (
              <p>
                Você removeu a conexão entre a Conta Globo e a {nameAccount}.
              </p>
            ) : (
              <p>
                Agora você poderá entrar na <b>{nameAccount}</b> utilizando sua
                Conta Globo.
              </p>
            )}

            <Button
              variant="primary"
              type="button"
              width="100%"
              onClick={() => {
                window.dataLayer.push({
                  event: 'customEventUserInteraction',
                  event_category: Categories.AssociateAccounts,
                  event_action: Actions.ClickConclude,
                  event_label: labelInverted + nameAccount,
                  bd_suser_code: user?.globoId,
                });

                history.goBack();
              }}
            >
              Concluir
            </Button>
          </Content>
        </Container>
      </>
    </>
  );
};

export default ManagerAccounts;
